import { Grid, Typography, makeStyles } from "@material-ui/core";
import { lang } from "../../../i18nLang";
import Dropzone from "../../UI/Dropzone";
import { Title } from "./styles";

const useStyles = makeStyles({
  text: {
    fontSize: "0.75rem",
    textAlign: "center",
    marginTop: "1rem",
  },
});

interface TabSelectFileProps {
  /** Evento para fazer o upload do arquivo */
  onDropFile: Function;
  /** Arquivo já selecionado */
  file: File | null;
  label: string;
}

/** Formulário para seleção de arquivo para importação de contrato.
 * @category Components
 */
const TabSelectFile = (props: TabSelectFileProps) => {
  const classes = useStyles();

  return (
    <>
      <Title>{lang(`importation.modeFile.subtitle1`)}</Title>
      <Grid container item xs={12} md={12} justifyContent="center">
        <Dropzone
          onDrop={props.onDropFile}
          accept=".xlsx, .xls"
          currentFiles={props.file ? [props.file] : undefined}
        />
        <Typography variant="body1" className={classes.text}>
          {lang(`importation.modeFile.fileCaption1`, props.label)}
          <b>.xls</b>
          {lang(`importation.modeFile.fileCaption2`)}
          <b>.xlsx</b>
          {lang(`importation.modeFile.fileCaption3`)}
        </Typography>
      </Grid>
    </>
  );
};

export default TabSelectFile;
